export default __webpack_public_path__ + "img/printer.933c7d48.svg";